import { Button, DialogActions, DialogContent, FormControl, Grid, Snackbar, Stack, Typography } from '@mui/material';
import { forwardRef } from 'react';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store/store';
import { RootState } from '../../../reducers';
import { setOpenAddPopulation, setOpenAlert, setPopulationActiveStep, setValidFile, validatePopulation } from '../../../store/adminHealthPlan.slice';
import Loading from '../../Shared/Loading';

const ChooseData = (props) => {
    const dispatch = useAppDispatch();
    const { alertMessage, currentHealthPlan, currentPopulation, openAlert, validFile } = useSelector((state: RootState) => state.adminHealthPlanSlice);
    const { file, setFile } = props;

    const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleCloseAlert = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        dispatch(setOpenAlert(false));
    };

    return (
        <>
            <Loading message="Validating.." />
            <Snackbar open={openAlert} onClose={handleCloseAlert} autoHideDuration={4000} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert onClose={handleCloseAlert} severity={'error'} sx={{ width: '100%' }}>
                    {alertMessage}
                </Alert>
            </Snackbar>
            <DialogContent>
                <FormControl fullWidth>
                    <Grid spacing={2} container p={2} sx={{ height: '65vh' }}>
                        <Grid size={12}>
                            <Stack>
                                <Typography variant="h4" marginBottom={3}>
                                    Choose & validate your data for import
                                </Typography>
                                <Typography variant="body1">Select your file and validate.</Typography>
                                <Typography variant="body1">Format should be same as sample file in previous step.</Typography>
                            </Stack>
                        </Grid>

                        <Grid size={12}>
                            <Stack direction={'row'} spacing={2} alignItems={'center'}>
                                <form id={'upload-form'}>
                                    <Button className="button-120" id="upload-btn" variant="contained" component="label">
                                        Upload File
                                        <input
                                            id="file"
                                            name="File"
                                            onChange={(e) => {
                                                setFile(e.target.files[0]);
                                                dispatch(setValidFile(true));
                                            }}
                                            type="file"
                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                            hidden
                                        />
                                    </Button>
                                </form>
                                {validFile && <Typography variant="h6">{file?.name || 'No file selected'}</Typography>}
                                {!validFile && (
                                    <Typography variant="h6" color="error">
                                        Invalid File
                                    </Typography>
                                )}
                            </Stack>
                        </Grid>
                    </Grid>
                </FormControl>
            </DialogContent>

            <DialogActions>
                <Button
                    className="button-120"
                    variant="outlined"
                    onClick={() => {
                        dispatch(setOpenAddPopulation(false));
                        dispatch(setOpenAlert(false));
                        setFile(null);
                    }}
                >
                    Close
                </Button>
                <Button className="button-120" variant="contained" onClick={() => dispatch(setPopulationActiveStep(0))}>
                    Previous
                </Button>
                <Button
                    className="button-120"
                    variant="contained"
                    disabled={!file}
                    onClick={() => dispatch(validatePopulation(file, currentHealthPlan.Id, currentPopulation.Id))}
                >
                    Validate
                </Button>
            </DialogActions>
        </>
    );
};

export default ChooseData;
